import type { z } from 'zod';
import type { recipeSchema } from '../schema.ts';
import { gear } from './gear.ts';
import { kitchen } from './kitchen.ts';

/**
 * Cross-skill recipes. Each needs two or more skills, usually from different Disciplines, and the
 * goods those skills produce. Made on the spot at a venue: no minigame, a fixed result.
 */
export const recipes: z.input<typeof recipeSchema>[] = [
  {
    key: 'fletched-arrows', name: 'Fletch arrows', venue: 'the-butts',
    description: 'Oak shafts and pheasant feathers: a score of arrows.',
    skills: [{ skill: 'woodcutting', level: 3 }, { skill: 'archery', level: 3 }],
    cost: { bar: 'focus', amount: 4 },
    inputs: [{ item: 'oak-log', quantity: 1 }, { item: 'brace-of-pheasants', quantity: 1 }],
    product: { item: 'arrow', quantity: 20 },
  },
  {
    key: 'flagon-of-mead', name: 'Brew mead', venue: 'brewhouse',
    description: 'Herbs, malt and a monk’s patience: two flagons.',
    skills: [{ skill: 'brewing', level: 6 }, { skill: 'alchemy', level: 3 }],
    cost: { bar: 'focus', amount: 5 },
    inputs: [{ item: 'barley', quantity: 2 }, { item: 'herbs', quantity: 2 }],
    product: { item: 'flagon-of-mead', quantity: 2 },
  },
  {
    key: 'hunters-feast', name: 'Hunter’s feast', venue: 'brewhouse',
    description: 'Two braces of pheasant roasted, and a cask to wash them down.',
    skills: [{ skill: 'hunting', level: 4 }, { skill: 'brewing', level: 4 }],
    cost: { bar: 'focus', amount: 6 },
    inputs: [{ item: 'brace-of-pheasants', quantity: 2 }, { item: 'cask-of-small-ale', quantity: 1 }],
    product: { item: 'hunters-feast', quantity: 1 },
  },
  {
    key: 'royal-banquet', name: 'Royal banquet', venue: 'brewhouse',
    description: 'A haunch, a brace of salmon and a cask of stout, laid on for a hall.',
    skills: [{ skill: 'hunting', level: 10 }, { skill: 'brewing', level: 10 }, { skill: 'fishing', level: 8 }],
    cost: { bar: 'focus', amount: 12 },
    inputs: [{ item: 'venison-haunch', quantity: 1 }, { item: 'salmon', quantity: 2 }, { item: 'cask-of-stout', quantity: 1 }],
    product: { item: 'royal-banquet', quantity: 1 },
  },
  // Bows, arrows, and cloth and leather armour (data/gear.ts).
  ...gear.recipes,
  // Meals (data/kitchen.ts).
  ...kitchen.recipes,
];
